import { SharedService } from 'src/app/services/shared.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private sharedService: SharedService){}
  title = 'Cyberspace LTE';


  ngOnInit() {
    this.sharedService.watchingUserActivity();    

  }


}
